<template>
    <div id="faq-form-popup" class="popup form-popup visible" @click.stop="">
        <div v-show="!loading && !sended">
            <p class="box-title center">Задайте вопрос</p>
            <p>{{msg}}</p>
            <form class="form" ref="form" novalidate>
                <field-wrapper type="select" label="Категория вопроса" v-model="category" :options="options"></field-wrapper>
                <field-wrapper type="textarea" label="Ваш вопрос" v-model="message" :options="{required: true}"></field-wrapper>
                <div class="field">
                    <div class="checkbox-item form-view"><input id="checkbox-inp11" name="checkbox-inp11" type="checkbox" v-model="publish">
                        <label for="checkbox-inp11">Не публиковать вопрос</label></div>
                </div>
                <button type="button" class="btn" @click="handleClick">{{btnText}}</button>
            </form>
        </div>
        <div v-show="!loading && sended">
            <p>{{msg}}</p>
            <button type="button" class="btn js-open-popup" @click="handleCloseClick">{{btnText}}</button>
        </div>
        <pre-loader-component :visible="loading" :small="false"></pre-loader-component>
        <span @click="$emit('close')" title="Закрыть" class="js-close-popup">
            <icon-base width="14" height="14" view-box="0 0 14 14" icon-name="Закрыть"><icon-close/></icon-base>
        </span>
    </div>
</template>

<script>

    import FieldWrapper from "../common/fields/FieldWrapper";
    import PreLoaderComponent from "../common/PreLoader";
    import {mapActions, mapMutations} from 'vuex'
    import CompleteComponent from "../common/CompleteComponent";
    import IconBase from "../common/IconBase";
    import IconClose from "../common/icons/IconClose";

    export default {
        name: 'ask-question-form',
        components: {
            IconBase,
            IconClose,
            PreLoaderComponent,
            FieldWrapper
        },
        computed:{
            btnText() {
                return this.sended ? 'Продолжить работу' : 'Отправить'
            },
        },
        data() {
            return {
                category: 'Вопрос 1',
                message: '',
                publish: false,
                options: {
                     values: ["Вопрос 1","Вопрос 2","Вопрос 3","Вопрос 4"],
                },
                sended: false,
                msg: "Если вы не нашли ответ на вопрос, задайте его через форму, предварительно выбрав категорию",
                loading: false
            }
        },
        methods: {
            ...mapActions('faq', ['sendQuestion']),
            ...mapActions([
                'switchPopup',
            ]),
            ...mapMutations([
                'setPopupComponent',
                'setPopupData',
            ]),
            handleCloseClick() {
                this.switchPopup(false).then(() => {
                    this.sended = false;
                });
            },

            handleClick() {
                if (!this.$refs.form.checkValidity()) {
                    this.$refs.form.reportValidity();
                } else {
                    this.loading = true;
                    this.sendQuestion({message: this.message, category: this.category, publish: this.publish}).then(() => {
                        this.setPopupData({msg: 'Спасибо за вопрос.<br>Мы пришлем ответ на ваш email'});
                        this.setPopupComponent(CompleteComponent);
                    });
                }
            },
        }
    }
</script>

<style scoped>

</style>
